export const TAX_CONDITIONS = {
  MONOTRIBUTISTA: "MONOTRIBUTISTA",
  RESPONSABLE_INSCRIPTO: "RESPONSABLE INSCRIPTO",
  IVA_EXENTO: "IVA EXENTO",
  IVA_NO_ALCANZADO: "IVA NO ALCANZADO",
  CONSUMIDOR_FINAL: "CONSUMIDOR FINAL",
};
